import axios from 'utils/axios';
import * as types from './ActionTypes';
import { API_URL } from 'configs';


import { showSuccessModal } from 'actions';

const loader = label => ({ type: types.SHOW_LOADER, common_loader_label: label });
const hideLoader = () => ({ type: types.HIDE_LOADER });

const snackbar = (msg, type = 'general_error') => ({
  type: types.SHOW_SNACKBAR,
  snackbar_notification: msg,
  snackbar_notification_type: type,
});

const handleError = (error, dispatch, validationType) => {
  const res = error?.response; 
  if (res?.status === 422){ 
    dispatch({ type: validationType, validation_error: res.data.errors });
  } 
  else dispatch(snackbar(res?.data?.error || `${res?.status} ${res?.statusText}`));
};

export const timeSheetTaskRedirectToList = () => ({ type: types.TASKS_REDIRECT });

const fetchSuccess = (type, listKey) => data => ({
  type,
  [listKey]: data
});

const getSuccess = (type) => (data, action) => ({
  type,
  record: data,
  actionType: action
});

export const hideTaskValidationError = (feild_key) => ({
  type: types.HIDE_TASKS_FEILD_VALIDATION_ERROR,
  feild_key: feild_key
})

export const fetchTasks = (params = {}) => dispatch => {
  dispatch({ type: types.TASKS_REQUEST });
  dispatch(loader());

  axios.post(`${API_URL}timesheet/tasks/list`, params, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
    .then(res => {
      dispatch(hideLoader());
      dispatch(fetchSuccess(types.TASKS_SUCCESS, 'tasksList')(res.data));
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.TASKS_VALIDATION_ERROR);
    });
};

export const getTaskById = (id, actionType, object_viewed_id) => dispatch => {
  dispatch({ type: types.TASKS_REQUEST });
  dispatch(loader());

  axios.get(`${API_URL}timesheet/tasks/${id}`, {
    params: { object_viewed_id },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
    .then(res => {
      dispatch(hideLoader());
      dispatch(getSuccess(types.TASKS_GET_SUCCESS)(res.data, actionType));
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.TASKS_VALIDATION_ERROR);
    });
};

export const createOrUpdateTask = (data, method = 'POST', object_viewed_id) => dispatch => {
  dispatch({ type: types.TASKS_REQUEST });
  dispatch(loader());

  const url = method === 'POST'
    ? `${API_URL}timesheet/tasks`
    : `${API_URL}timesheet/tasks/${data.id}`;

  axios({
    url,
    method,
    data,
    params: { object_viewed_id },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
    .then(() => {
      dispatch(hideLoader());
      dispatch(showSuccessModal(`Task ${method === 'POST' ? 'created' : 'updated'} successfully`));
      dispatch(timeSheetTaskRedirectToList());
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.TASKS_VALIDATION_ERROR);
    });
};

export const deleteTask = (id, object_viewed_id) => dispatch => {
  dispatch({ type: types.TASKS_REQUEST });
  dispatch(loader());

  axios.delete(`${API_URL}timesheet/tasks/${id}`, {
    params: { object_viewed_id },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
    .then(() => {
      dispatch(hideLoader());
      dispatch(snackbar('Task deleted', 'success'));
      dispatch(timeSheetTaskRedirectToList()); 
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.TASKS_VALIDATION_ERROR);
    });
};

export const fetchTimesheetTasksDropdown = (data) => dispatch => {
  dispatch({ type: types.TASKS_REQUEST });
  axios.post(`${API_URL}timesheet/tasks/dropdown`, data, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem("token")}`
    },
  })
    .then(res => {
      dispatch(fetchSuccess(types.TASKS_DROPDOWN_SUCCESS, 'tasksDropdownList')(res.data));
    })
    .catch(err => {
      handleError(err, dispatch, types.TASKS_VALIDATION_ERROR);
    });
};

